import { render, staticRenderFns } from "./approvalHistoryModal.vue?vue&type=template&id=07da93c7"
import script from "./approvalHistoryModal.vue?vue&type=script&lang=js"
export * from "./approvalHistoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports